export default "__VITE_ASSET__DRt28vtf__"